import { NonIguanaFrame } from 'NonIguanaFrame';
import { type FrameViewModel } from 'Lessons/FrameViewModel';
import { angularInjectorProvider } from 'Injector';
import { type TranslationHelperClass } from 'Translation';
import { FreeResponseFrameViewModel } from './FreeResponseFrameViewModel';
import './locales/free_response/free_response-en.json';

type FreeResponseAttrs = {
    promptInstructions?: string;
};

const getMiniInstructions = (): string => {
    const TranslationHelper = angularInjectorProvider.get<TranslationHelperClass>('TranslationHelper');
    const helper = new TranslationHelper('free_response.free_response');
    return helper.get('respond_to_prompt');
};

export class FreeResponseFrame extends NonIguanaFrame<FreeResponseAttrs> {
    // This looks ugly, but I tried hard to implement it differently with
    // generics and failed
    static FrameViewModel = FreeResponseFrameViewModel as typeof FrameViewModel;
    directiveName = 'free-response-player-ui';
    infoPanelDirectiveName = 'free-response-editor';
    buttonDirectiveName = 'free-response-button';
    private _miniInstructions?: string;

    get miniInstructions(): string {
        if (this._miniInstructions) return this._miniInstructions;
        this._miniInstructions = getMiniInstructions();
        return this._miniInstructions;
    }

    get frameType() {
        return 'FreeResponse';
    }

    get promptInstructions(): string {
        return this.attrs.promptInstructions || '';
    }

    set promptInstructions(value: string) {
        this.attrs.promptInstructions = value;
    }
}
